/**
 * Created by Alican Köker on 2019-01-09.
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { ScalableLayer } from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { EdisonGameConfig } from "../../EdisonGameConfig";
import { TimelineLite } from "gsap";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { EdisonHelper } from "../../../utils/EdisonHelper";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { EdisonGameMode } from "../../gameMode/EdisonGameMode";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { EdisonGameModuleConfig } from "../../EdisonGameModuleConfig";
import { EdisonFreespinSwoopOverlay } from "./EdisonFreespinSwoopOverlay";
import { EdisonMetersOverlay } from "./EdisonMetersOverlay";

export class EdisonFreespinOverlay extends BaseView {


    private _spineSprite:PIXI.Sprite;
    private _spineSpritePosition:number[] = [640, 320];
    private _spineSpritePositionLandscape:number[] = [640, 320];
    private _spineSpritePositionPortrait:number[] = [640, 120];

    private _plusOneContainer:PIXI.Container;

    private _layer:ScalableLayer;

    //data
    private _restoreMode:boolean = false;

    private _skinNames:string[] = ["Black", "White", "Red", "Purple", "Blue", "Green"];

    private _orientation:Orientation = Orientation.LANDSCAPE;

    private _blinkSpineContainerSprite:PIXI.Sprite;

    private _gameMode:EdisonGameMode = EdisonGameMode.FREESPIN;

    public static readonly SET_MODE:string = "edisonFreespinOverlay_setMode";

    protected _swooshView:EdisonFreespinSwoopOverlay;
    protected _metersView:EdisonMetersOverlay;

    constructor() {
        super();

        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.FREESPIN_OVERLAY.name);
        EventHandler.addEventListener(this, EdisonFreespinOverlay.SET_MODE, (event:GameEvent) => this._gameMode = event.params[0]);
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.resetBlinkContainer());

        /** init swoop overlay*/
        this._spineSprite = new PIXI.Sprite();
        this._swooshView = new EdisonFreespinSwoopOverlay();

        this._metersView = new EdisonMetersOverlay();
        this._plusOneContainer = new PIXI.Container();

        this._layer.addChild(this._metersView);
        this._layer.addChild(this._plusOneContainer);
    }

    protected initAnimations():void {
        this.initBlinkSpine();

        if(this._restoreMode) {
            EdisonGameModuleConfig.background.currentMode = EdisonGameMode.FREESPIN;
        }

        this._layer.visible = this._restoreMode;
        this._layer.addChild(this._swooshView);
    }


    private initBlinkSpine():void {
        this._blinkSpineContainerSprite = new PIXI.Sprite();
        this._layer.addChild(this._blinkSpineContainerSprite);
    }

    public playSwooshAnim(index:number):void {
        if(!this._spineSprite.visible)
            this._spineSprite.visible = true;

        this._swooshView.playSwooshAnimByColor(index);
    }

    public activateView():void {
        this._layer.visible = true;
    }

    public deactivateView():void {
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this.visible = false;
        }, this._orientation === Orientation.PORTRAIT ? 5 : 4);

        tl.add(() => this._metersView.deactivateView());
    }

    public set restoreMode(value:boolean) {
        this._restoreMode = value;
    }

    protected onResize(resizeData:IResizeData):void {
        this.reposition(resizeData.orientation);
        this._orientation = resizeData.orientation;
    }

    private reposition(orientation:Orientation):void {

        const isPortrait:boolean = orientation === Orientation.PORTRAIT;

        this._spineSpritePosition = isPortrait ? this._spineSpritePositionPortrait : this._spineSpritePositionLandscape;

        this._spineSprite.position.set(this._spineSpritePosition[0], this._spineSpritePosition[1]);
    }

    public blinkGoldSwitch(reelIndex:number, symbolIndex:number, featureSymIndex:number):void {
        this._swooshView.playBlinkAnimation(reelIndex, symbolIndex, this._skinNames[featureSymIndex]);
    }

    public playBlinkAnimation(reelIndex:number, symbolIndex:number, featureSymbolIndex:number):TimelineLite {

        const symW:number = EdisonGameConfig.instance.SYMBOL_WIDTH;
        const symH:number = EdisonGameConfig.instance.SYMBOL_HEIGHT;

        let blinkSpine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("blinkSpine"));
        this._blinkSpineContainerSprite.addChild(blinkSpine);

        if(featureSymbolIndex === -1)
            return new TimelineLite();

        blinkSpine.skeleton.setSkinByName(this._skinNames[featureSymbolIndex]);

        let pos:number[] = EdisonHelper.getSymbolPosition(reelIndex, symbolIndex);


        let diff:number = this._orientation === Orientation.PORTRAIT ? -100 : 0;

        blinkSpine.position.set(pos[0] + symW / 2, pos[1] + diff + symH / 2);

        let tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            blinkSpine.state.setAnimation(0, "GreenBlink", false);
        });

        return tl;
    }

    private resetBlinkContainer():void {
        this._blinkSpineContainerSprite.removeChildren();
    }

    public meterCap(meterIndex:number):number {
        return this._metersView.meterCap(meterIndex);
    }

    public resetMeterBgSequence(meterIndex:number):void {
        this._metersView.resetMeterBgSequence(meterIndex);
    }

    public playInitMetersAnimations(init:Boolean):void {
        this._metersView.playInitMetersAnimations(init);
    }

    public updateMeterValues(values:number[]):TimelineLite {
        return this._metersView.updateMeterValues(values);
    }

    public resetMeterLights(meterIndex:number):void {
        this._metersView.resetMeterLights(meterIndex);
    }

}